module.exports = __webpack_public_path__ + "static/media/gavel.bdd68617.png";